<script setup>
  import {onBeforeMount, ref} from "vue";

  import ComponentInput from "@components/Inputs/Input.vue";

  defineOptions({
    name: "ComponentTimeSelect",
  });

  const props = defineProps({
    value: {
      type: [String, ref],
      default: "",
    },
  });

  const emit = defineEmits(["selectedTime"]);

  const refHourField = ref(null);
  const refMinuteField = ref(null);

  const selectedTime = ref(null);
  const hour = ref(null);
  const minute = ref(null);

  onBeforeMount(() => {
    if (props.value !== null) {
      const time = props.value.split(":");
      hour.value = time[0];
      minute.value = time[1];
    }
  });

  const handleChange = () => {
    if (hour.value && hour.value.length === 2) {
      refMinuteField.value.focus();
    }

    if (minute.value === null) {
      minute.value = "00";
    }

    selectedTime.value = hour.value + ":" + minute.value;
    emit("selectedTime", {
      time: selectedTime.value,
    });
  };
</script>

<template>
  <div class="ml-8 flex">
    <ComponentInput
      ref="refHourField"
      v-model="hour"
      time-select="hourField"
      type="text"
      class="w-9!"
      autocomplete="off"
      maxlength="2"
      :show-maxlength-count="false"
      input-alignment="text-center"
      hide-clear
      @input="handleChange"
    />

    <span class="px-1 pt-1">:</span>

    <ComponentInput
      ref="refMinuteField"
      v-model="minute"
      time-select="minuteField"
      type="text"
      maxlength="2"
      :show-maxlength-count="false"
      class="w-9!"
      autocomplete="off"
      input-alignment="text-center"
      hide-clear
      @input="handleChange"
    />

    <span class="pt-2 text-sm">Uhr</span>
  </div>
</template>
